require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-jun-cajigal.json") })
        }
      }, "path---member-jun-cajigal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-jun-cajigal!./.cache/json/member-jun-cajigal.json
// module id = 400
// module chunks = 231608221292675